<div class="p-6 ml-3">
  <img src="../assets/webtree.png" alt="">
</div>

<div class="mb-6">
  <div class="col-md-8 d-flex justify-content-center mx-auto text-center">
    <div class="d-flex mx-auto">
      <!-- <span class="mr-2">
        <img src="../assets/new-product.png">
      </span> -->
      <span>
        <p class="f-28 mb-2">
          Welcome to Webbtree!
        </p>
        <p class="f-16 text-center" style="color: #777777">
          Let's get you started...
        </p>
      </span>
    </div>
  </div>
  <div class="col-md-8 justify-content-center mx-auto text-center">
    <div style="border: 1px dotted #206c79; background-color: #ffffff;padding: 26px 32px 24px 27px;">
      <img src="../assets/group.png">
      <div class="text-left mb-3 mt-3">
        <p class="f-16">
          Webbtree's Chrome Extension helps you source, enrich and nurture talent from across the web
        </p>

        <p class="f-14 d-flex " style="color: #777777;"><span><i class="fas fa-circle mr-3 f-10"
              style="color: #777777;"></i></span>Grab candidates you discover on LinkedIn, GitHub, Stack Overflow,
          Kaggle,
          Naukri, Career Builder and build talent pools.</p>
        <p class="f-14 d-flex mb-3" style="color: #777777;"> <span><i class="fas fa-circle mr-3 f-10"
              style="color: #777777;"></i></span> Find contact number, email addresses and social profiles of candidate
          you discover. </p>
      </div>

      <div class="pointer d-flex justify-content-center align-items-center">
        <button data-testid="auto-app-firstlogin-button-1" class="btn-trms-medium" (click)="routeURL()">
          Add chrome extension</button>
        <p class="mb-0 ml-3" style="color: #2e93a1;" (click)="routeURL('dashboard')">
          Go to dashboard
        </p>
      </div>
    </div>
  </div>
</div>

<!--
<div class="mt-6 pt-6" *ngIf="!isChromeBrowser">
  <div class="col-md-5 text-center m-auto mt-6 pt-6">
    <div style="border: 1px dotted #206c79; background-color: #ffffff;padding: 26px 32px 24px 27px;">
      <img src="../assets/sad-face-two-color.png">
      <div class="mb-4 mt-4">
        <p class="f-16">
          Browser not supported!
        </p>

        <p class="f-14">
          Use Google chrome to acess Webbtree extension.
        </p>
      </div>

      <div class="pointer">
        <button data-testid="auto-app-firstlogin-button-2" class="wc-btn bg-blue m-auto py-2 my-3" (click)="routeURL('dashboard')">
          Go to dashboard</button>
      </div>
    </div>
  </div>
</div> -->
